import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import queryString from 'qs';
import {withRouter} from 'react-router-dom';

import TrackingMapToDataLayer from './map-to-datalayer';

@withRouter
export default class TrackingPageViewMapper extends PureComponent {
  render() {
    const {location, match = {}, data} = this.props;
    const {search} = location;
    const {url, path} = match;

    const pageView = {
      url,
      path,
      ...data,
    };

    const queryParams = _getQueryParams(search);
    if (Object.keys(queryParams).length) {
      pageView.queryParams = queryParams;
    }

    return <TrackingMapToDataLayer dataKey="pageView" data={pageView} />;
  }
}

TrackingPageViewMapper.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  data: PropTypes.object,
};

function _getQueryParams(search) {
  if (search && search.length) {
    return queryString.parse(search.slice(1));
  }

  return {};
}
